module.exports = __webpack_public_path__ + "img/48128a7.jpg";